export default "__VITE_ASSET__DLsdod8N__"